import { useState } from "react";
import { aiWritingAssistantRepo } from "@/lib/repositories";
import type { ApiDilemma } from "@/features/dilemmas/types";
import type { AiGenerateRequest } from "../types";

// Imperative wrapper (no useMutation) so the global MutationCache error toast
// doesn't fire on top of the caller's own catchError handling.
export function useGenerateDilemma() {
  const [isPending, setIsPending] = useState(false);

  async function generate(payload: AiGenerateRequest): Promise<ApiDilemma> {
    setIsPending(true);
    try {
      return await aiWritingAssistantRepo.generate(payload);
    } finally {
      setIsPending(false);
    }
  }

  return { generate, isPending };
}
